import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Resource } from "../resources/types";
import { CacheRenderedResourceAction } from "./types";

type RenderCacheState = Record<string, Record<string, Resource>>;

const initialState: RenderCacheState = {};

const rendererSlice = createSlice({
  name: 'renderCache',
  initialState,
  reducers: {
    cacheRenderedResource: (state, action: PayloadAction<CacheRenderedResourceAction>) => {
      const { resource, themeID } = action.payload;
      if (!state[themeID]) {
        state[themeID] = {};
      }
      state[themeID][resource.id] = resource;
    },
    invalidateAll: () => ({}),
    invalidateTheme: (state, action: PayloadAction<string>) => {
      state[action.payload] = {};
    },
    invalidateResourceByID: (state, action: PayloadAction<string>) => {
      for (const cache of Object.values(state)) {
        delete cache[action.payload];
      }
    }

  }
});

export const rendererActions = rendererSlice.actions;

export default rendererSlice.reducer;
